import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter";
import Git from "./Git";
import LatestNews from "./LatestNews";
import { usePromotionBanners } from "../admin/contexts/PromotionBannerContext";
import "../assets/style.css";
import "../assets/Home.css";
import "../assets/bootstrap/bootstrap.min.css";

const Home: React.FC = () => {
  const { banners, loading, getBannerImage } = usePromotionBanners();
  const validBanners = useMemo(() => banners || [], [banners]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (validBanners.length <= 1) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % validBanners.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [validBanners]);

  useEffect(() => {
    if (activeIndex >= validBanners.length) {
      setActiveIndex(0);
    }
  }, [validBanners, activeIndex]);

  useEffect(() => {
    if (validBanners.length <= 1 || isHovered) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % validBanners.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [validBanners, isHovered]);

  return (
    <>
      {/* HOME */}
      <section id="home">
        <div
          id="carousel"
          className="carousel slide carousel-fade"
          data-ride="carousel"
        >
          {/* Carousel items */}
          <div className="carousel-inner">
            <div className="carousel-item active slides">
              <div className="slide-1"></div>
              <div className="hero ">
                <hgroup className="wow fadeInUp">
                  <h2>The next big idea … </h2>
                  <h1>
                    <span
                      style={{
                        background: "linear-gradient(45deg, #FFD700, #C5A000)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                      }}
                    >
                      <Typewriter
                        words={[
                          "ERP Software",
                          "POS Solution",
                          "IT Services",
                          "Hardware",
                        ]}
                        loop={true}
                        cursor
                        cursorStyle="|"
                        typeSpeed={70}
                        deleteSpeed={50}
                        delaySpeed={2000}
                      />
                    </span>
                  </h1>
                  <h3>ERP & POS Software Malaysia | LyraZone ICT Solutions</h3>
                </hgroup>
                <Link
                  to="/contact"
                  className="btn btn-general btn-silver"
                  role="button"
                >
                  Contact Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ABOUT */}
      <section id="about" className="about">
        <div className="container">
          <div className="row title-bar">
            <div className="col-md-12">
              <h1 className="wow fadeInUp">We are committed to helping</h1>
              <div className="heading-border"></div>
              <p className="wow fadeInUp" data-wow-delay="0.4s">
                LyraZone provides ERP, POS, accounting software support, POS
                hardware, and custom web/app development solutions for retail,
                restaurant, wholesale, and service businesses in Malaysia and
                through out the World.
              </p>
              <div className="title-but">
                <Link
                  to="/careers"
                  className="btn btn-general btn-silver"
                  role="button"
                >
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* About right side withBG parallax */}
        <div className="container-fluid">
          <div className="row">
            <div
              className="col-md-3 col-sm-6 bg-atlantis"
              style={{ width: "90%" }}
            >
              <div
                className="about-content-box wow fadeInUp"
                data-wow-delay="0.3s"
              >
                <i className="fa fa-snowflake-o"></i>
                <h5>Leadership Platform</h5>
                <p className="desc">
                  It is a long established fact that a seeker will be distracted
                  by the provider if the choice of seeker is wrong. But we will
                  never disappoint you.
                </p>
              </div>
            </div>
            <div
              className="col-md-3 col-sm-6 bg-silver"
              style={{ width: "90%" }}
            >
              <div
                className="about-content-box wow fadeInUp"
                data-wow-delay="0.5s"
              >
                <i className="fa fa-circle-o-notch"></i>
                <h5>Corporate World Platform</h5>
                <p className="desc">
                  We are fully equipped to provide all those Services which
                  falls under our Services.
                </p>
              </div>
            </div>
            <div
              className="col-md-3 col-sm-6 bg-black"
              style={{ width: "90%" }}
            >
              <div
                className="about-content-box wow fadeInUp"
                data-wow-delay="0.7s"
              >
                <i className="fa fa-hourglass-o"></i>
                <h5>End to End Testing Platform</h5>
                <p className="desc">
                  Our goal is to complete the job(s) we take and deliver it
                  after End-to-End Testing and full satisfaction.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* OFFERS */}
      <section id="comp-offer">
        <div className="container-fluid">
          <div className="row">
            <div
              className="col-md-3 col-sm-6 desc-comp-offer wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <h2>What We Offer</h2>
              <div className="heading-border-light"></div>
              <Link
                to="/services"
                className="btn btn-general btn-silver"
                role="button"
              >
                See Current Offers
              </Link>
              <Link
                to="/contact"
                className="btn btn-general btn-white"
                role="button"
              >
                Contact Us Today
              </Link>
              <div
                className="wwo-promotion-banner"
                style={{ width: "auto", height: "200px" }}
              >
                {!loading && validBanners.length > 0 ? (
                  <div
                    className="wwo-promotion-carousel"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    <div
                      className="wwo-promotion-track"
                      style={{
                        transform: `translateX(-${activeIndex * 100}%)`,
                      }}
                    >
                      {validBanners.map((banner) => (
                        <a
                          key={banner.id}
                          href={banner.link || "#"}
                          className="wwo-promotion-link"
                          target={
                            banner.link?.startsWith("http") ? "_blank" : "_self"
                          }
                          rel="noreferrer"
                          aria-label={banner.title}
                        >
                          <div className="wwo-promotion-card">
                            <img
                              src={getBannerImage(banner.image)}
                              alt={banner.title}
                              className="wwo-promotion-image"
                            />
                            <span className="promotion-cta">
                              <span className="promotion-cta-text">
                                ✨ Get Promotion
                              </span>
                            </span>
                          </div>
                        </a>
                      ))}
                    </div>

                    {validBanners.length > 1 && (
                      <div className="wwo-promotion-dots">
                        {validBanners.map((_, index) => (
                          <button
                            key={index}
                            type="button"
                            className={`wwo-promotion-dot ${
                              activeIndex === index ? "active" : ""
                            }`}
                            onClick={() => setActiveIndex(index)}
                            aria-label={`Go to banner ${index + 1}`}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
            </div>

            <div
              className="col-md-3 col-sm-6 desc-comp-offer wow fadeInUp"
              data-wow-delay="0.4s"
            >
              <div className="desc-comp-offer-cont">
                <div className="thumbnail-blogs">
                  <div className="caption">
                    <Link to="/software">
                      <i className="fa fa-chain"></i>
                    </Link>
                  </div>
                  <img
                    src="/images/news/news-11.jpg"
                    className="img-fluid"
                    alt="Software"
                  />
                </div>
                <h3>Software</h3>
                <p className="desc">
                  We deliver smart Software solutions including Accounting, POS,
                  ERP, and business management systems that improve efficiency,
                  accuracy, and decision-making for modern organizations.
                </p>
                <Link to="/software">
                  <i className="fa fa-arrow-circle-o-right"></i> Our SAAS
                </Link>
              </div>
            </div>
            <div
              className="col-md-3 col-sm-6 desc-comp-offer wow fadeInUp"
              data-wow-delay="0.6s"
            >
              <div className="desc-comp-offer-cont">
                <div className="thumbnail-blogs">
                  <div className="caption">
                    <Link to="/hardware">
                      <i className="fa fa-chain"></i>
                    </Link>
                  </div>
                  <img
                    src="/images/news/news-13.jpg"
                    className="img-fluid"
                    alt="Hardware"
                  />
                </div>
                <h3>Hardware</h3>
                <p className="desc">
                  We supply reliable Hardware products through trusted partners,
                  ensuring quality performance, durability, and the right
                  technology support for your business operations.
                </p>
                <Link to="/hardware">
                  <i className="fa fa-arrow-circle-o-right"></i> Shop Now
                </Link>
              </div>
            </div>
            <div
              className="col-md-3 col-sm-6 desc-comp-offer wow fadeInUp"
              data-wow-delay="0.8s"
            >
              <div className="desc-comp-offer-cont">
                <div className="thumbnail-blogs">
                  <div className="caption">
                    <Link to="/testimonials">
                      <i className="fa fa-chain"></i>
                    </Link>
                  </div>
                  <img
                    src="images/news/news-14.jpg"
                    className="img-fluid"
                    alt="..."
                  ></img>
                </div>
                <h3>Web & App Development</h3>
                <p className="desc">
                  We create professional websites and applications tailored to
                  your goals, helping businesses strengthen their digital
                  presence, improve engagement, and grow with confidence.
                </p>
                <Link to="/testimonials">
                  <i className="fa fa-arrow-circle-o-right"></i> Our Clients
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* WHAT WE DO */}
      <section className="what-we-do bg-gradiant">
        <div className="container-fluid">
          <div className="row">
            {/* Left Title Section */}
            <div className="col-md-3">
              <h3>What we Do</h3>
              <div className="heading-border-light"></div>
              <p className="desc">
                We make partners, not clients, for strong and long-lasting
                relationships.
              </p>
            </div>

            {/* Right Services Section */}
            <div className="col-md-9">
              <div className="row">
                <div className="col-md-4 col-sm-6">
                  <div className="what-we-desc">
                    <i className="fa fa-briefcase"></i>
                    <h6>ERP Application</h6>
                    <p className="desc">
                      Our accounting suites help you manage your business.
                    </p>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="what-we-desc">
                    <i className="fa fa-shopping-bag"></i>
                    <h6>eCommerce Stores</h6>
                    <p className="desc">
                      We develop and run our own eCommerce Stores with a wide
                      range of products.
                    </p>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="what-we-desc">
                    <i className="fa fa-building-o"></i>
                    <h6>Point of Sales</h6>
                    <p className="desc">
                      Our POS System manages your retail business with online
                      mobile reporting.
                    </p>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="what-we-desc">
                    <i className="fa fa-bed"></i>
                    <h6>Hotel Management</h6>
                    <p className="desc">
                      Our Hotel Management System will provide you business
                      activities at your fingertips.
                    </p>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="what-we-desc">
                    <i className="fa fa-hourglass-2"></i>
                    <h6>Web & App Concepts</h6>
                    <p className="desc">
                      Tell us your idea, and we'll bring it to life on your
                      gadget.
                    </p>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="what-we-desc">
                    <i className="fa fa-cutlery"></i>
                    <h6>POS Restaurant</h6>
                    <p className="desc">
                      Point of Sales Restaurant will manage your restaurant's
                      tables, sales, and customers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Success Story */}
      <section id="story">
        <div className="container">
          <div className="row title-bar">
            <div className="col-md-12">
              <h1 className="wow fadeInUp">Our Success Transformation</h1>
              <div className="heading-border"></div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              <div className="story-himg">
                <img
                  src="/images/image-4.jpg"
                  className="img-fluid"
                  alt="Success Story"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="story-desc">
                <h3>How to grow world with Us</h3>
                <div className="heading-border-light"></div>
                <p style={{ textAlign: "justify" }}>
                  At LyraZone, we believe growth begins with innovation,
                  collaboration, and opportunity. We work with businesses,
                  professionals, and young talent to build smarter digital
                  solutions that create real impact in today’s fast-changing
                  world. Our mission is not only to support business success but
                  also to open doors for career development through job
                  opportunities and student internships. We welcome passionate
                  individuals who are ready to learn, contribute, and grow with
                  us.
                </p>
                <p style={{ textAlign: "justify" }}>
                  By combining technology, creativity, and practical experience,
                  LyraZone creates an environment where ideas become solutions,
                  skills become strengths, and people become part of meaningful
                  progress for a better connected future.
                </p>
                <p
                  className="text-right"
                  style={{ fontStyle: "italic", fontWeight: 700 }}
                >
                  <Link to="#">LyraZone</Link>
                </p>
                <div className="title-but">
                  <Link
                    to="/careers"
                    className="btn btn-general btn-silver"
                    role="button"
                  >
                    Find Career
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Success Stories */}
        <div className="container">
          <div className="row">
            <div
              className="col-md-4 col-sm-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="story-descb">
                <img
                  src="/images/news/news-10.jpg"
                  className="img-fluid"
                  alt="Virtual Training"
                />
                <h6>Virtual Systems</h6>
                <p>
                  LyraZone offers based on virtualization, no matter you can
                  approach us in person or not. We are committed to deliver
                  valuable services.
                </p>
                <Link to="software">
                  <i className="fa fa-arrow-circle-o-right"></i> Read More
                </Link>
              </div>
            </div>
            <div
              className="col-md-4 col-sm-6 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="story-descb">
                <img
                  src="/images/news/news-2.jpg"
                  className="img-fluid"
                  alt="Design Planning"
                />
                <h6>Design Planning</h6>
                <p>
                  We design applications and reports that provide accurate data
                  and visual insights for better business decisions and
                  planning.
                </p>
                <Link to="software">
                  <i className="fa fa-arrow-circle-o-right"></i> Read More
                </Link>
              </div>
            </div>
            <div
              className="col-md-4 col-sm-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="story-descb">
                <img
                  src="/images/news/news-8.jpg"
                  className="img-fluid"
                  alt="Remote Support"
                />
                <h6>Remote Support</h6>
                <p>
                  LyraZone provides remote ticket base support, because reliable
                  technology solutions always depend on timely human expertise.
                </p>
                <Link to="support">
                  <i className="fa fa-arrow-circle-o-right"></i> Read More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Company Thoughts */}
      <>
        {/* Background Overlay */}
        <div className="overlay-thought"></div>

        <section id="thought" className="bg-parallax thought-bg">
          <div className="container">
            <div
              id="thought-desc"
              className="row title-bar title-bar-thought owl-carousel owl-theme"
            >
              <div className="col-md-12">
                <div className="heading-border bg-white"></div>
                <p className="wow fadeInUp" data-wow-delay="0.4s">
                  LyraZone will deliver value to all the stakeholders and will
                  attain excellence and leadership through such delivery of
                  value. We will strive to support the stakeholders in all
                  activities related to us. LyraZone provides great things.
                </p>
                <h6>John Doe</h6>
              </div>

              <div className="col-md-12 thought-desc">
                <div className="heading-border bg-white"></div>
                <p className="wow fadeInUp" data-wow-delay="0.4s">
                  Ensuring quality in LyraZone is an obsession, and the
                  high-quality standards set by us are achieved through a
                  rigorous quality assurance process. Quality assurance is
                  performed by an independent team of trained experts for each
                  project.
                </p>
                <h6>Tom John</h6>
              </div>
            </div>
          </div>
        </section>
      </>
      <section id="service-h">
        <div className="container-fluid">
          <div className="row">
            {/* Left Video Section */}
            <div className="col-md-6">
              <div className="service-himg">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/oVYXPYeUJ4Q"
                  title="YouTube video playe"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* Right Services Description Section */}
            <div className="col-md-6 wow fadeInUp" data-wow-delay="0.3s">
              <div
                className="service-h-desc"
                style={{ padding: "0px 10px 0px 0px" }}
              >
                <h3>We are Providing Great Services</h3>
                <div className="heading-border-light"></div>
                <p>
                  LyraZone offers the full spectrum of services to help our
                  clients work better. Everything from creating standards of
                  excellence to training your people to work in more effective
                  ways.
                </p>

                {/* Tab Section */}
                <div className="service-h-tab">
                  <nav className="nav nav-tabs" id="myTab" role="tablist">
                    <a
                      className="nav-item nav-link active"
                      id="nav-home-tab"
                      data-toggle="tab"
                      href="#nav-home"
                      role="tab"
                      aria-controls="nav-home"
                      aria-expanded="true"
                    >
                      Software Training
                    </a>
                    <a
                      className="nav-item nav-link"
                      id="nav-profile-tab"
                      data-toggle="tab"
                      href="#nav-profile"
                      role="tab"
                    >
                      Accounting Support
                    </a>
                    <a
                      className="nav-item nav-link"
                      id="my-profile-tab"
                      data-toggle="tab"
                      href="#my-profile"
                      role="tab"
                    >
                      Management Tools
                    </a>
                  </nav>

                  {/* Tab Content */}
                  <div
                    className="tab-content"
                    id="nav-tabContent"
                    style={{
                      padding: "0px 10px 0px 0px",
                      textAlign: "justify",
                    }}
                  >
                    <div
                      className="tab-pane fade show active"
                      id="nav-home"
                      role="tabpanel"
                      aria-labelledby="nav-home-tab"
                    >
                      <p>
                        Our team is deeply committed to software deployment and
                        hands-on training until every trainee fully understands
                        the system. We know that clients adopting
                        computerization for the first time need time, guidance,
                        and patience to adjust confidently. That is why we
                        remain supportive throughout the process, ensuring
                        smooth learning, successful adoption, and maximum value
                        from the system.
                      </p>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="nav-profile"
                      role="tabpanel"
                      aria-labelledby="nav-profile-tab"
                    >
                      <p>
                        During the implementation of Accounting Software, we
                        have observed that some operators may not have a
                        commerce background, which can lead to unbalanced
                        accounts and incorrect charting. There is no need to
                        worry. Our team provides the necessary guidance,
                        support, and training to help users operate the system
                        correctly and maintain accurate, error-free accounting
                        records.
                      </p>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="my-profile"
                      role="tabpanel"
                      aria-labelledby="my-profile-tab"
                    >
                      <p>
                        The market offers a wide range of ERP Software
                        solutions. We work closely with trusted and reputable
                        providers, allowing us to recommend the most suitable
                        system based on each client’s business nature and
                        specific requirements. Our partnerships are built on
                        confidence, quality, and proven performance, ensuring
                        clients receive reliable solutions supported by
                        dependable service and professional expertise.
                      </p>
                    </div>
                  </div>
                </div>
                {/* End of Tab Section */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Client */}
      {/* <section id="client" className="client">
        <div className="container">
          <div className="row title-bar">
            <div className="col-md-12">
              <h1 className="wow fadeInUp">Our Clients Say</h1>
              <div className="heading-border"></div>
              <p className="wow fadeInUp" data-wow-delay="0.4s">
                We are committed to helping you maintain your brand value.
              </p>
            </div>
          </div>
          
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <div className="client-cont wow fadeInUp" data-wow-delay="0.1s">
                <img
                  src="/images/client/avatar-6.jpg"
                  className="img-fluid"
                  alt="Client 1"
                />
                <h5>Kavish</h5>
                <h6>
                  Director
                  <br />
                  Bright Max Trading Sdn. Bhd.
                </h6>
                <i className="fa fa-quote-left"></i>
                <p>
                  The Lyra Zone Solutions truly have solutions that help in
                  business progress and increase our show-up rate whenever
                  required.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="client-cont wow fadeInUp" data-wow-delay="0.3s">
                <img
                  src="/images/client/avatar-2.jpg"
                  className="img-fluid"
                  alt="Client 2"
                />
                <h5>Faisal Zahoor</h5>
                <h6>
                  Director
                  <br />
                  ZyMal Textile Sdn. Bhd.
                </h6>
                <i className="fa fa-quote-left"></i>
                <p>
                  I found Lyra Zone perfect in solutions and services. Not only
                  did I get the solutions, but I also got peace of mind. Thanks,
                  Lyra Zone.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-sm-12">
              <div className="client-cont wow fadeInUp" data-wow-delay="0.5s">
                <img
                  src="/images/client/avatar-1.jpg"
                  className="img-fluid"
                  alt="Client 3"
                />
                <h5>Kumar</h5>
                <h6>
                  General Manager
                  <br />
                  Premier "K" Removal & Services
                </h6>
                <i className="fa fa-quote-left"></i>
                <p>
                  Lyra Zone saved us! Their services are awesome. Now our
                  accounts are healthy & well-managed. Great job, Lyra Zone.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="client-cont wow fadeInUp" data-wow-delay="0.3s">
                <img
                  src="/images/client/avatar-3.jpg"
                  className="img-fluid"
                  alt="Client 4"
                />
                <h5>Wong</h5>
                <h6>
                  Director
                  <br />
                  Libta Coffee
                </h6>
                <i className="fa fa-quote-left"></i>
                <p>
                  Lyra Zone provided excellent services to settle our accounts
                  for the financial year 2020. Warm regards, Lyra Zone.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <Git />
      <LatestNews />
      {/* <Footer /> */}
    </>
  );
};

export default Home;
